import axios from 'axios';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  // List graded submissions with filters (Admin only)
  async getGradedSubmissions(_obj, params) {
    const res = await axios.get(`api/lms/assignment-submissions/all-submissions/`, { params });
    return res;
  },

  // Get submission details for grading (Admin only)
  async getGradedSubmissionDetails(_obj, id) {
    const res = await axios.get(`api/lms/graded-submissions/${id}/`);
    return res;
  },

  // Submit grade for a submission (Admin only)
  async submitGrade(_obj, { id, data }) {
    const res = await axios.post(`api/lms/graded-submissions/${id}/grade/`, data);
    return res.data;
  },

  // List pending submissions (Admin only)
  async getPendingSubmissions(_obj, params) {
    const res = await axios.get(`api/lms/graded-submissions/pending/`, { params });
    return res.data;
  },

  // List graded submissions (Admin only)
  async getGradedSubmissionsList(_obj, params) {
    const res = await axios.get(`api/lms/graded-submissions/graded/`, { params });
    return res.data;
  },

  // Update review status (Admin only)
  async updateReviewStatus(_obj, { id, status }) {
    const res = await axios.patch(`api/lms/graded-submissions/${id}/update-status/`, {
      review_status: status,
    });
    return res.data;
  },

  // Get assignment submission details (Student side)
  async getAssignmentSubmission(_obj, id) {
    const res = await axios.get(`api/lms/assignment-submissions/${id}/`);
    return res.data;
  },

  // Update assignment submission status
  async updateAssignmentSubmission(_obj, { id, data }) {
    const res = await axios.patch(`api/lms/assignment-submissions/${id}/`, data);
    return res.data;
  },

  // Re-run AI grading for a submission. Allowed when review_status
  // is one of: ai_grading_failed | in_review | pending. Returns the
  // refreshed AssignmentGradeSerializer payload.
  async retryAiGrade(_obj, id) {
    const res = await axios.post(`api/lms/graded-submissions/${id}/retry-ai-grade/`);
    return res.data;
  },
};

export const gradedSubmissions = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
